// typeof window !== 'undefined' checks because otherwise it will result in vue serverside errors
export const mq: Record<'S' | 'M' | 'L' | 'XL', MediaQueryList> = {
	S: (typeof window !== 'undefined' && window.matchMedia('screen and (max-width: 620px)')) as MediaQueryList,
	M: (typeof window !== 'undefined' &&
		window.matchMedia('screen and (min-width: 621px) and (max-width: 980px)')) as MediaQueryList,
	L: (typeof window !== 'undefined' &&
		window.matchMedia('screen and (min-width: 981px) and (max-width: 1440px)')) as MediaQueryList,
	XL: (typeof window !== 'undefined' && window.matchMedia('screen and (min-width: 1441px)')) as MediaQueryList
};

export default mq;
